import { GraphicElement } from '../graphicelements/graphicelement';

export class EditArea {
  public graphicElement: GraphicElement;
  // TODO: add concrete model: DataElement?
  // public allDataElement: Array<any>;

}
